module.exports = __webpack_public_path__ + "img/icon_location_active.3e814c5f.png";